:host {
  display: block;
  margin: 0px;
  padding: 0px;
  font-family: var(--primary-font);
  background-color: var(--color-white);
  overflow: hidden;

  @include breakpointMax("md") {
    &.no-img {
      max-height: unset
    }
  }

  &.no-img {
    max-height: unset
  }
}

.hero {
  position: relative;
  // mixin.scss

  &.no-img {
    .content {
      min-height: unset;
      position: relative;
    }
  }

  @include breakpointMax("md") {
    &.no-img {
      min-height: unset;
      padding-top: 10px;

      .content {
        min-height: unset;
        position: relative;
      }
    }
  }

  .content {
    position: absolute;
    top:0;
    padding-top: 62px;

    @include layerIndex('second');

    @include mainPadding;

    .no-img {
      padding-top: 15px;
    }

    @include breakpointMax("md") {
      padding-top: 35px;
      min-height: 370px;
    }


  }

  ::slotted(lilu-breadcrumb) {
    padding: 0;
    padding-bottom: 15px;
  }

  ::slotted(lilu-heading) {
    padding-bottom: 15px;
  }

  ::slotted(lilu-img) {
    min-width: 100%;
    height: 100%;
    position: relative;
    top: 0px;
    left: 0px;
    @include layerIndex('first');
  }

  ::slotted(lilu-p){
    width: clamp(1px, 100%, 600px);
  }
}
